import type { TableColumnsType } from 'antd';
import * as Yup from 'yup';
import type { Leadership, OrganizationUnitListType } from './OrganizationUnitLists.types.ts';
import { Translation } from 'react-i18next';
import { HomeOutlined } from '@ant-design/icons';
import i18n from '../../utils/i18n.ts';

export const ORGANIZATION_UNIT_LISTS_FORM = 'OrganizationUnitListsForm';

export const BREADCRUMBS = [
  {
    href: '/',
    title: <HomeOutlined />,
  },
  {
    href: '/',
    title: i18n.t('common.portal'),
  },
  {
    href: '/admin',
    title: i18n.t('pages.admin.title'),
  },
  {
    title: i18n.t('pages.admin.module.organization-unit-lists'),
  },
];

export const ORGANIZATION_UNIT_LISTS_COLUMNS: TableColumnsType<OrganizationUnitListType> = [
  {
    title: i18n.t('pages.organization-unit-lists.name'),
    dataIndex: 'title',
  },
  {
    title: i18n.t('pages.organization-unit-lists.order'),
    dataIndex: 'order',
  },
  {
    title: i18n.t('pages.organization-unit-lists.type'),
    dataIndex: 'type',
    render: (value: number) => (value === 1 ? 'Regions' : 'Headquarters'),
  },
  {
    title: i18n.t('pages.organization-unit-lists.abbreviation'),
    dataIndex: 'abbreviation',
  },
  {
    title: (
      <Translation>
        {(t) => <>{t('pages.organization-unit-lists.parent-abbreviation')}</>}
      </Translation>
    ),
    dataIndex: 'parentAbbreviation',
  },
  {
    title: i18n.t('pages.organization-unit-lists.leadership'),
    dataIndex: 'leadershipInfo',
    render: (values: Leadership[]) =>
      values?.map((value) => value.displayName).join(', ') ||
      i18n.t('pages.organization-unit-lists.no-leadership'),
  },
  {
    title: i18n.t('pages.organization-unit-lists.selectable'),
    dataIndex: 'selectable',
    width: 150,
    render: (value: string) => (value ? i18n.t('common.yes') : i18n.t('common.no')),
  },
];

export const ORGANIZATION_UNIT_LISTS_FORM_SCHEMA = {
  title: Yup.string().required(i18n.t('error.validation.required-name')),
  order: Yup.string().required(i18n.t('error.validation.required-order')),
  type: Yup.string().required(i18n.t('error.validation.required-type')),
  abbreviation: Yup.string().required(i18n.t('error.validation.required-abbreviation')),
  selectable: Yup.boolean(),
  leadership: Yup.array()
    .of(
      Yup.object().shape({
        value: Yup.string().required('Entra ID is required'),
      }),
    )
    .required(i18n.t('error.validation.required-leadership'))
    .min(1, i18n.t('error.validation.required-leadership')),
};

export const ORGANIZATION_UNIT_LISTS_INITIAL_FORM_VALUES = {
  id: null,
  title: '',
  order: 1,
  type: null,
  abbreviation: '',
  parentAbbreviation: '',
  leadership: null,
  selectable: true,
};
